import React from 'react';
import {createRoot} from 'react-dom/client';
import RootPage from './RootPage';
import './styles.scss';

createRoot(document.getElementById('root')!).render(<RootPage/>);
